<loading-overlay [isLoading]="isLoading"></loading-overlay>
<header class="flex header">
  <h2>{{ getTranslation('Color_Lab_Dips_Modal_Title', { colorName: colorName || '' }) }}</h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>

<section class="content">
  <p>{{ getTranslation('Color_Lab_Dips_Modal_Info') }}</p>
  @if (canEdit) {
    <div class="form-box mt-5">
      <label for="labDipTypeahead">{{ getTranslation('Color_Lab_Dips_Modal_Lab_Dip_To_Add') }}</label>
      <p-autoComplete #labDipSearch="cslServerSearch" [cslServerSearch]="labDipTypeahead" [suggestions]="labDipSearch.results()" [formControl]="selectedLabDip" />
    </div>
  }

  <div>
    <div class="flex" *ngFor="let labDipId of labDipIds.value">
      <a (click)="onLabDipClick(labDipId)">
        {{ labDipId }}
      </a>
      @if (canEdit) {
        <p-button icon="pi pi-trash" (click)="unassignLabDip(labDipId)" />
      }
    </div>
  </div>
</section>

<footer>
  <p-button class="w-full" [label]="getTranslation('Color_Lab_Dips_Modal_Cancel')" variant="outlined" (click)="onClose()" />
</footer>
